export class EpisodeOfCareCriticalParams {
  public ci: string;
  public network_id: string;
  public geo_location: string;
  public procedure_id: string;
  public provider_id?: string;
  public location_id?: string;

  constructor(params: any) {
    this.ci = params.ci;
    this.network_id = params.network_id;
    this.geo_location = params.geo_location;
    this.procedure_id = params.procedure_id;
    this.provider_id = params.provider_id || null;
    this.location_id = params.location_id || null;
  }
}
